<!-- customise table columns -->
<div id="column-select-accordion" class="mb-1">
  @if (columns.length > 1) {
    <div class="card br-6 box-shadow border-0">
      <div class="card-header border-0" id="column-select-container">
        <h5 class="my-2 d-flex justify-content-between">
          <span class="d-inline-flex align-items-center">
            Customise the table to view data that best fit your needs.
          </span>

          @switch (selectColumnCardShow) {
            @case (true) {
              <app-vficon
                iconPack="source-system-icons"
                iconName="chevron-up"
                data-bs-toggle="collapse"
                data-bs-target="#column-container"
                aria-expanded="true"
                aria-controls="column-container"
                style="cursor: pointer"
                (click)="selectColumnCardShowHide()"
              ></app-vficon>
            }
            @case (false) {
              <app-vficon
                iconPack="source-system-icons"
                iconName="chevron-down"
                data-bs-toggle="collapse"
                data-bs-target="#column-container"
                aria-expanded="true"
                aria-controls="column-container"
                style="cursor: pointer"
                (click)="selectColumnCardShowHide()"
              ></app-vficon>
            }
          }
        </h5>
      </div>
      @if (selectColumnCardShow) {
        <div class="hr"></div>
      }
      <div
        id="column-container"
        class="collapse"
        aria-labelledby="column-select-container"
        data-parent="#column-select-accordion"
      >
        <div class="card-body">
          <table class="table px-3">
            <tbody>
              @for (columnBatch of batchesData; track columnBatch) {
                <tr class="mx-2">
                  @for (column of columnBatch; track column) {
                    <td class="py-3">
                      <input
                        type="checkbox"
                        [disabled]="disabled"
                        class="me-2"
                        style="position: relative; top: 1px"
                        [name]="column.title"
                        [id]="column.title"
                        [checked]="column.selected"
                        (click)="selectColumnChangeHandler($event, column)"
                      />
                      <label [for]="column.title">{{ column.label || column.title }}</label>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
          <div class="d-flex">
            <div class="column-select-button-container">
              <button [disabled]="disabled" type="button" class="btn btn-primary me-3" (click)="showSelectedColumns()">
                Save
              </button>
              <button [disabled]="disabled" type="button" class="btn btn-dark" (click)="showAllColumns()">
                Show All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!disableDownload) {
    <div class="dropdown dropup border-0 d-flex justify-content-end align-items-center ps-4" style="margin-left: auto">
      <p class="h6 mt-3">Download</p>
      <button
        [disabled]="disabled"
        class="btn dropdown-toggle border-0"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-cy="download-dropdown"
      >
        <app-vficon iconName="download" iconPack="source-mid-render-light-icons"></app-vficon>
      </button>
      <div class="dropdown-menu">
        <button [disabled]="disabled" class="dropdown-item" (click)="clickDownload('all')" data-cy="dl-all">
          Download
        </button>
        <!--      <button class="dropdown-item" (click)="clickDownload('filtered')" data-cy="dl-filtered">Download Filtered</button>-->
        @if (downloadSelected) {
          <button [disabled]="disabled" class="dropdown-item" (click)="clickDownload('selected')" data-cy="dl-selected">
            Download Selected
          </button>
        }
      </div>
    </div>
  }
</div>
